import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 px-4 bg-[#2B0A3D] text-white text-center" data-id="element-46">
      <div className="max-w-4xl mx-auto" data-id="element-47">
        <h2 className="text-3xl md:text-5xl font-bold font-playfair mb-6" data-id="element-48">
          Empieza hoy. <br data-id="element-49" />
          <span className="text-[#D4AF37] italic" data-id="element-50">
            En 21 días puedes sentirte diferente.
          </span>
        </h2>

        <p className="text-xl text-white/80 mb-10" data-id="element-51">
          No por magia. Por estructura + claridad + acción.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-52">
          <Button href="#oferta" variant="primary" size="xl" className="w-full sm:w-auto min-w-[280px] shadow-xl shadow-[#D4AF37]/20" data-id="element-53">
            Comprar ahora por $7.97
          </Button>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-white/50" data-id="element-54">
            <span className="flex items-center gap-1" data-id="element-55">
              <Zap className="w-4 h-4" data-id="element-56" /> Acceso inmediato
            </span>
            <span data-id="element-57">•</span>
            <span data-id="element-58">Digital</span>
            <span data-id="element-59">•</span>
            <span className="flex items-center gap-1" data-id="element-60">
              <ShieldCheck className="w-4 h-4" data-id="element-61" /> Pago seguro
            </span>
          </div>
        </div>
      </div>
    </section>;
}